import {
  VALIDATE_TOKEN,
  TOKEN_VALID,
  TOKEN_INVALID,
  TOKEN_EXPIRING,
  SHOW_EXPIRATION_WARNING,
  HIDE_EXPIRATION_WARNING,
  RENEW_TOKEN,
  CLEAR_TOKEN_ERROR
} from './actions';

const initialState = {
  isValidating: false,
  isValid: false,
  token: null,
  expiresAt: null,
  timeRemaining: null,
  error: null,
  showWarning: false,
  isRenewing: false
};

const tokenValidationReducer = (state = initialState, action) => {
  switch (action.type) {
    case VALIDATE_TOKEN:
      return {
        ...state,
        isValidating: true,
        error: null
      };

    case TOKEN_VALID:
      return {
        ...state,
        isValidating: false,
        isValid: true,
        token: action.payload.token,
        expiresAt: action.payload.expiresAt,
        error: null,
        showWarning: false
      };

    case TOKEN_INVALID:
      return {
        ...state,
        isValidating: false,
        isValid: false,
        token: null,
        expiresAt: null,
        timeRemaining: null,
        error: action.payload.error,
        showWarning: false
      };

    case TOKEN_EXPIRING:
      return {
        ...state,
        isValidating: false,
        isValid: true,
        token: action.payload.token,
        expiresAt: action.payload.expiresAt,
        timeRemaining: action.payload.timeRemaining,
        showWarning: true,
        error: null
      };

    case SHOW_EXPIRATION_WARNING:
      return {
        ...state,
        showWarning: true,
        timeRemaining: action.payload.timeRemaining
      };

    case HIDE_EXPIRATION_WARNING:
      return {
        ...state,
        showWarning: false,
        timeRemaining: null
      };

    case RENEW_TOKEN:
      return {
        ...state,
        isRenewing: true,
        showWarning: false
      };

    case CLEAR_TOKEN_ERROR:
      return {
        ...state,
        error: null,
        isValidating: false
      };

    default:
      return state;
  }
};

export default tokenValidationReducer;
